module.exports = __webpack_public_path__ + "static/images/pick-up-with-shadow.kWKyKop.svg";